/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, 
  animation: splashAnimation,
  duration: 2000 
};


const illustration = {
  animated: true 
};

const greeting = {
  username: "ArbKoci",
  title: "Hello there, I'm Arb",
  subTitle: emoji(
    "A passionate Full Stack Software Developer specialized in web and mobile apps for FinTech, eCommerce, SaaS, and AI/ML solutions. Skilled in building intelligent systems that combine scalable architecture with modern user experiences.Currently based in Tirane,Albania."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1ofFdKF_mqscH8WvXkSObnVvC9kK7Ldlu/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/arbdoescode",
  linkedin: "https://www.linkedin.com/in/arb-ko%C3%A7i-1b884b213",
  gmail: "arbkociii@gmail.com",
  instagram: "https://www.instagram.com/arbkoci/",
  // gitlab: "https://gitlab.com/saadpasta",
  // facebook: "https://www.facebook.com/saad.pasta7",
  // medium: "https://medium.com/@saadpasta",
  // stackoverflow: "https://stackoverflow.com/users/10422806/saad-pasta",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "CRAZY FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji(
      "⚡ Develop highly interactive Front end / User Interfaces for your web and mobile applications"
    ),
    emoji("⚡ Progressive Web Applications ( PWA ) in normal and SPA Stacks"),
    emoji(
      "⚡ Integration of third party services such as Firebase/ AWS / Digital Ocean"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "C++",
      fontAwesomeClassname: "fab fa-cs"
    },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "swiftUI",
      fontAwesomeClassname: "fab fa-swift"
    },
    {
      skillName: "Java",
      fontAwesomeClassname: "fab fa-java"
    },
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "php",
      fontAwesomeClassname: "fab fa-php"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    // {
    //   skillName: "aws",
    //   fontAwesomeClassname: "fab fa-aws"
    // },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Epoka University",
      logo: require("./assets/images/logo_epoka_uni.png"),
      subHeader: "Bachelor of Science in Computer Engineering",
      duration: "September 2019 - June 2022",
      desc: "Participated in the research and development of a postal courier management.",
      descBullets: [
        "Developed a full-stack application aimed at helping postal service couriers manage, track, and update package deliveries efficiently. The system included user authentication, package status tracking, and administrative dashboards.",
        "Specialized in Software Development & Systems Design, with hands-on experience in backend, frontend, and database systems using tools like Python, JavaScript, and SQL.",
        "Graduated with a strong academic record, completing advanced coursework in Algorithms, Computer Networks, Operating Systems, and AI."
      ]
    },
    
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "70%"
    },
    {
      Stack: "Programming",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Software Engineer",
      company: "Facebook",
      companylogo: require("./assets/images/facebookLogo.png"),
      date: "June 2018 – Present",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      descBullets: [
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      ]
    },
    {
      role: "Front-End Developer",
      company: "Quora",
      companylogo: require("./assets/images/quoraLogo.png"),
      date: "May 2017 – May 2018",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    },
    {
      role: "Software Engineer Intern",
      company: "Airbnb",
      companylogo: require("./assets/images/airbnbLogo.png"),
      date: "Jan 2015 – Sep 2015",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/saayaHealthLogo.webp"),
      projectName: "Saayahealth",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://saayahealth.com/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/nextuLogo.webp"),
      projectName: "Nextu",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://nextu.se/"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Google Code-In Finalist",
      subtitle:
        "First Pakistani to be selected as Google Code-in Finalist from 4000 students from 77 different countries.",
      image: require("./assets/images/codeInLogo.webp"),
      imageAlt: "Google Code-In Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing"
        },
        {
          name: "Award Letter",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
        },
        {
          name: "Google Code-in Blog",
          url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
        }
      ]
    },
    {
      title: "Google Assistant Action",
      subtitle:
        "Developed a Google Assistant Action JavaScript Guru that is available on 2 Billion devices world wide.",
      image: require("./assets/images/googleAssistantLogo.webp"),
      imageAlt: "Google Assistant Action Logo",
      footerLink: [
        {
          name: "View Google Assistant Action",
          url: "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en"
        }
      ]
    },

    {
      title: "PWA Web App Developer",
      subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
      image: require("./assets/images/pwaLogo.webp"),
      imageAlt: "PWA Logo",
      footerLink: [
        {name: "Certification", url: ""},
        {
          name: "Final Project",
          url: "https://pakistan-olx-1.firebaseapp.com/"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: true // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+355692210502",
  email_address: "arbkociii@gmail.com"
};

// Twitter Section
const brandWorked = {
 brandImg :[ 
  {
    brandImg:require("./assets/images/gjejevete.png")
  },
  {
    brandImg:require("./assets/images/WesternUnionLogo.png")
  },
  {
    brandImg:require("./assets/images/albaniancourier.png")
  },
  {
    brandImg:require("./assets/images/pronaral.png")
  },
  {
    brandImg:require("./assets/images/ozzo.png")
  },
  {
    brandImg:require("./assets/images/vodafone.png")
  },
  {
    brandImg:require("./assets/images/onetel.png")
  },
  {
    brandImg:require("./assets/images/dpa.png")
  },
{
    brandImg:require("./assets/images/baboon.png")
  },
]
}

const infoCarusel = {
 infocarusel :[ 
  {
    info:"Design System"
  },
  {
    info:"Mobile App"
  },
  {
    info:"Software Development"
  },
  {
    info:"Backend Engineering"
  },
  {
    info:"Documentation"
  },
  {
    info:"Features Enhancment"
  },
  {
    info:"Kit Maintenance"
  }
]
}

const backgroudProjects = {
 sliderone :[ 
  {
    projectImg:require("./assets/images/sliderrandom1.webp")
  },
  {
    projectImg:require("./assets/images/sliderrandom2.webp")
  },
  {
    projectImg:require("./assets/images/sliderrandom3.webp")
  },
  {
    projectImg:require("./assets/images/sliderrandom4.webp")
  },
  {
    projectImg:require("./assets/images/sliderrandom5.webp")
  },
],
slidertwo :[ 
  {
    projectImg:require("./assets/images/Upayslider1.jpg")
  },
  {
    projectImg:require("./assets/images/Upayslider2.jpg")
  },
  {
    projectImg:require("./assets/images/Upayslider3.jpg")
  },
  {
    projectImg:require("./assets/images/testfilebg.avif")
  },
  {
    projectImg:require("./assets/images/sliderrandom11.webp")
  },
],
sliderthree :[ 
  {
    projectImg:require("./assets/images/sliderrandom6.webp")
  },
  {
    projectImg:require("./assets/images/sliderrandom7.webp")
  },
  {
    projectImg:require("./assets/images/sliderrandom8.webp")
  },
  {
    projectImg:require("./assets/images/sliderrandom9.webp")
  },
  {
    projectImg:require("./assets/images/sliderrandom10.webp")
  },
]
}

export const Projects = {
  UPay: [
    {
      name:"UPay",
      header: "Boosting UPay's Expansion Across Albania and Europe",
      year:"2023-Now",
      role:"Android and iOS Developer, UI/UX Designer, Backend Engineer",

      images:{
        main:require("./assets/images/upaymainpic.jpg")
      },

      info:[
        {
          question:"What was the problem?",
          answer:"Expanding UPay’s reach to serve businesses across multiple regions was a significant challenge. When the opportunity to scale the platform arose, the goal was clear: deliver a seamless, secure, and intuitive payment experience for users from diverse markets. It was an ambitious target, with high expectations for performance and reliability.", 
        },
        {
          question:"Redesign and Start Programming from Scratch.",
          answer:"I led the redesign of the UPay app by creating and implementing the UI/UX designs for both Android and iOS, giving the app a fresh and modern look. Beyond the design, I helped expand its features to include QR code payments, money transfers between different accounts, and utility bill payments like phone, tickets, electricity, and water. This journey shaped the app into a powerful, must-have digital wallet that simplifies everyday transactions for everyone.",
          button:[
            {
              text:"Play Store",
              imgs:require("./assets/images/android.png"),
              url:"https://play.google.com/store/apps/details?id=com.uft.emoney&hl=en"
            },{
              text:"App Store",
              imgs:require("./assets/images/appstore.png"),
              url:"https://apps.apple.com/al/app/upay-albania/id1518207112"
            }
        ]
        },
        {
          image:require("./assets/images/upayexplanimg.jpg")
        },
        {
          question:"Scaling in new levels",
          answer:"As our user base grew and the platform needed to scale, we introduced biometric authentication combined with ID card verification for citizens of Albania, Kosovo, and North Macedonia. This enhancement significantly boosted security and user trust, making the app more reliable and compliant with regional regulations while providing a smooth and secure login experience.We also integrated Western Union transactions into the app, a process that involved not only developing the necessary features and creating approval models but also maintaining continuous communication with Western Union’s headquarters. This close collaboration ensured we met all requirements and secured the green light to successfully deploy the feature."
        },
        {
          question:"Engineering Security Models",
          answer:"I architected and implemented a comprehensive security system for our digital banking platform, incorporating multi-layered protections such as two-factor authentication (2FA), Time-Based One-Time Passwords (TOTP), secure socket acceptance protocols, and IP location tracking to identify and flag suspicious activities in real time. Throughout the process, I actively developed core security features while providing technical guidance and mentorship to my team, ensuring we met stringent security standards and delivered a robust, reliable solution that safeguarded user data and transactions.",
          
        
        },
      ]

    }
  ],
  SeekFake: [
    {
      name:"SeekFake",
      header: "Exposing Deepfakes and misinformation with machine intelligence.",
      year:"2025-Now",
      role:"Lead Developer, Machine Learning Engineer, AI solutions Architect",

      images:{
        main:require("./assets/images/seekfakemainimg.jpg")
      },
      info:[
        {
          question:"What is SeekFake?",
          answer:"SeekFake is an intelligent fact-verification system designed to determine the authenticity of news articles, social media posts, and general online information. Leveraging advanced Natural Language Processing (NLP) and real-time data from trusted sources, the program assesses the credibility of any given claim or news snippet.",
          button:[
            {
              text:"Documentation",
              imgs:require("./assets/images/paper.png"),
              url:"https://github.com/arbdoescode/SeekFake"
              
            }
        ]
        },
        {
          image:require("./assets/images/seekfakemacbook.jpg")
        },
        {
          question:"Open Source and AI-Powered",
          answer:"My startup, SeekFake, is at the forefront of combating the growing threat of deepfakes, leveraging advanced AI to accurately capture and verify manipulated media. In an era where synthetic content can be incredibly convincing, SeekFake offers a crucial solution for distinguishing genuine images, videos, and audio from fabricated ones, safeguarding against misinformation and digital fraud. We're also big believers in the power of community, which is why we'll be making our core detection technology freely available to the public, empowering developers and researchers worldwide to contribute to and benefit from our advancements in deepfake detection.",
          
        
        },
      ]
    }
  ],
  AlbanianCourier: [
    {
      name:"Albanian Courier",
      header: "Expanding across Albania and Kosovo, managing international orders.",
      year:"2021-2022",
      role:"Frontend Web Developer, Junior Software Developer",

      images:{
        main:require("./assets/images/albaniancouriermainimg.jpg")
      },
      info:[
        {
          question:"What was my role?",
          answer:"As a Junior Web Developer, I played a key role in enhancing the company's digital infrastructure. I was primarily responsible for developing the courier panel using React Native, ensuring a modern, responsive, and efficient interface for our couriers. Beyond development, I actively contributed to the deployment of our Android application, making it accessible to a wider network of couriers. My responsibilities also included providing crucial support in fixing bugs on the backend system, which was vital for maintaining the stability and reliability of our courier operations."
        },
        {
          question:"Elevating myself with new challanges",
          answer:"In addition to my core responsibilities, I independently developed a custom desktop application. This tool was designed to streamline the tracking of orders specifically from major fashion retailers like Zara, Massimo Dutti, and Bershka, providing an internal solution to monitor the delivery lifecycle of these high-volume shipments."
        },
        {
          image:require("./assets/images/AlbanianCourierdesc.jpg")
        },
        
      ]

    }
  ],
  UPayPos: [
    {
      name:"UPay POS",
      header: "An Application Built to Help Merchants and Businesses Scale",
      year:"2022-2024",
      role:"Lead Developer, Android and IOs Developer, Engineering Manager, UI/UX Designer",

      images:{
        main:require("./assets/images/upayposmainpic.jpg")
      },
      info:[
        {
          question:"The First Project I Led, Many More Ahead",
          answer:"UPay POS was the first project I led as a developer — a significant milestone in my career. It’s a powerful payment solution designed to help businesses collect payments effortlessly through QR codes, NFC, or payment links. From concept to deployment, I was responsible for leading development, ensuring a smooth and secure user experience while solving real-world payment challenges.",
          button:[
            {
              text:"Play Store",
              imgs:require("./assets/images/android.png"),
              url:"https://play.google.com/store/apps/details?id=com.uft.upaypos&hl=en"
            },{
              text:"App Store",
              imgs:require("./assets/images/appstore.png"),
              url:"https://apps.apple.com/al/app/upaypos/id6447762687"
            }
        ]
        },
        {
          question:"Developing with SwiftUI and Android Studio",
          answer:"During this project, I took full ownership of the mobile experience by developing both the iOS and Android applications. I also crafted the UI/UX design to ensure a smooth and intuitive interface for users. On the backend side, I collaborated closely with the team, offering technical guidance and aligning the system architecture with the app’s needs. This end-to-end involvement not only strengthened my technical skills but also shaped my ability to lead and coordinate across disciplines.",
        },
        {
          image:require("./assets/images/upayposexplenation.jpg")
        },
        {
          question:"Inovation and new technologies",
          answer:"I also integrated the application with Android-based POS devices, extending its functionality to support in-person payments. This included enabling card transactions and NFC tap-to-pay features, transforming standard POS hardware into a versatile payment terminal. This integration made the solution even more valuable for merchants seeking a unified and seamless payment experience.",
        },
        {
          question:" ",
          answer:"One of the key challenges I faced was ensuring secure communication with banking systems. I tackled this by implementing custom encryption and decryption processes, and by generating encrypted files to safeguard sensitive payment data. Overcoming these security hurdles was crucial in meeting compliance standards and building trust with financial partners."
        }
      ]

    }
  ],
  // Add more projects...
};


const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: true // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection,
  brandWorked,
  backgroudProjects,
  infoCarusel
};
